import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import envConfig from "src/envConfig/envHelper";

/**
 * This function is modified from
 * https://newrelic.com/blog/how-to-relic/custom-instrumentation-with-the-new-relic-browser-agent
 * to comply with the lint rule of this project
 * @returns
 */
function createBrowserAgent() {
  if (envConfig && envConfig.newRelic) {
    // Populate using values in copy-paste JavaScript snippet.
    const options = {
      init: { ...envConfig.newRelic.init }, // NREUM.init
      info: { ...envConfig.newRelic.info }, // NREUM.info
      loader_config: { ...envConfig.newRelic.loader_config }, // NREUM.loader_config
    };

    // The agent loader code executes immediately on instantiation.
    const browserAgent = new BrowserAgent(options);
    return browserAgent;
  } else {
    return undefined;
  }
}

const browserAgent = createBrowserAgent();

export default browserAgent;
